import React, { useState, useEffect } from "react";
import moment from "moment";
import axios from "../../../../axios";
import * as url from "../../../../utils/url";
import * as actionCreators from "../../../../modules/actions/index";
import Loading from "../../../../hoc/Loading/Loading";
import { connect } from "react-redux";
import {
  Input,
  Modal,
  ModalBody,
  Button,
  ModalHeader,
  ModalFooter,
} from "reactstrap";
import Select from "react-select";
import sortBy from "lodash.sortby";
import { toastContainer } from "../../../../utils/toast";
import "../menu-modals-bwai.css";

function TrivvyEnterpriseConfigsModal({
  open,
  onClose,
  user,
  orgChangeSuccess,
  heading="Organization Info",
  onUpdateSuccess
}) {
  const [industryId, setIndustryId] = useState();
  const [industryList, setIndustryList] = useState([]);
  const [mission, setMission] = useState("");
  const [values, setValues] = useState("");

  useEffect(() => {
    axios.get(url.getMasterListByCategory("INDUSTRY")).then(({ data }) => {
      setIndustryList(sortBy(data.data[0].docs, "name"));
      if (user && user.profile && user.profile.organizationId) {
        const mission = user.profile.organizationId.mission;
        const values = user.profile.organizationId.values;
        setMission(mission);
        setValues(values);
      }

      if (
        user &&
        user.profile &&
        user.profile.organizationId &&
        user.profile.organizationId.industry &&
        user.profile.organizationId.industry._id
      ) {
        setIndustryId(user.profile.organizationId.industry._id);
      }
    });
  }, []);

  const handleSaveData = () => {
    axios
      .post(url.updateIndustryMissionValues, {
        orgId: user.profile.organizationId._id,
        industry: industryId,
        mission,
        values,
      })
      .then(({ data }) => {
        orgChangeSuccess({
          industry: data.data.industry,
          mission: data.data.mission,
          values: data.data.values,
        });
        toastContainer("Info updated successfully","success");
        if(onUpdateSuccess){
          onUpdateSuccess()
        }
        onClose()
      })
      .catch((err) => {
        toastContainer("Error updating organization info","error");
      });
  };

  return (
    <div>
      <Modal
        isOpen={open}
        className="bwai-modal bwai_menu_modal bwai_org_info"
      >
        <ModalHeader className="bwai_modal_header" toggle={onClose}>
          {heading}
        </ModalHeader>
        <ModalBody>
          <div className="mt-5">
            <div className="row">
              <div className="col-md-4 col-lg-4 text-right pick-office-col-title pt0">
                Enterprise Industry
              </div>
              <div className="col-md-6 col-lg-6">
                <Select
                  value={industryId}
                  options={
                    industryList
                      ? industryList.map((i) => ({
                          value: i._id,
                          label: i.name,
                        }))
                      : []
                  }
                  onChange={(e) => {
                    if (e) {
                      setIndustryId(e.value);
                    } else {
                      setIndustryId(null);
                    }
                  }}
                  clearable={false}
                />
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-md-4 col-lg-4 text-right pick-office-col-title pt0">
                Mission
              </div>
              <div className="col-md-6 col-lg-6">
                <Input
                  className="bwai_textarea bwai_org_textarea"
                  type={"textarea"}
                  value={mission}
                  onChange={(e) => {
                    setMission(e.target.value);
                  }}
                  rows={5}
                />
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-md-4 col-lg-4 text-right pick-office-col-title pt0">
                Values
              </div>
              <div className="col-md-6 col-lg-6">
                <Input
                  className="bwai_textarea bwai_org_textarea"
                  type={"textarea"}
                  value={values}
                  onChange={(e) => {
                    setValues(e.target.value);
                  }}
                  rows={5}
                />
              </div>
            </div>
          </div>
        </ModalBody>

        <ModalFooter className="bwai_org_footer">
          <Button color="primary" onClick={handleSaveData}>
            <span className="">
              Save
              {/* <span className="ml10 flaticon-tick"></span> */}
            </span>
          </Button>

          <Button onClick={() => onClose()}>Cancel</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onIndustryChangeSuccess: (data) =>
      dispatch(actionCreators.industryChangeSuccess(data)),
    orgChangeSuccess: (data) => dispatch(actionCreators.orgChangeSuccess(data)),
    orgEmailRemove: (data) => dispatch(actionCreators.orgEmailRemove(data)),
    orgSlackUrlRemove: (data) =>
      dispatch(actionCreators.orgSlackUrlRemove(data)),
    orgTenantIdRemove: (data) =>
      dispatch(actionCreators.orgTenantIdRemove(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TrivvyEnterpriseConfigsModal);
